export function isSampleBoardTechnicalPdf(file) {
  const base = String(file?.name || file?.path || "")
    .replace(/\\/g, "/")
    .split("/")
    .pop()
    .trim();
  return /^tablero(\.pdf$|\s+-)/i.test(base);
}

export function pickFirstTechnicalSheetPage(pages) {
  return Array.isArray(pages) ? pages[0] || null : null;
}

/** Fichas: solo 1ª hoja. Tablero Product Tree: todas. */
export function pickTechnicalSheetPages(pages, { allPages = false } = {}) {
  if (!Array.isArray(pages) || !pages.length) return [];
  return allPages ? pages : pages.slice(0, 1);
}
